export const paths = {
  INCOMING: 'incoming',
  OUTGOING: 'outgoing',
}
